<template>
  <BtnZzimTemplate
    :title="title"
    :wrapperClass="'check-like ' + getIconStyle"
    :check-state="value"
    :toggleFn="toggle"
  />
</template>
<script>
import BtnZzimTemplate from '@/components/button/BtnZzimTemplate'
import { mapMutations } from 'vuex'
import { showRequiredLoginPopup } from '@/common/utils/common'
import cookie from '@/common/utils/cookie'
import constant from '@/common/resources/constant'
import { deleteZzimContents, postZzimContentsDetail } from '@/common/utils/request'
import _ from 'lodash'
import ZzimMixIn from '@/mixins/zzim.mixin'

export default {
  name: 'BtnZzimWithApi',
  mixins: [
    ZzimMixIn
  ],
  components: { BtnZzimTemplate },
  props: {
    index: {
      type: Number,
      default: 0
    },
    isOn: {
      type: String,
      default: 'n',
      required: true
    },
    contentsType: {
      type: String,
      required: true
    },
    contentsId: {
      type: String,
      required: true
    },
    isMypooq: {
      type: Boolean,
      default: false
    },
    blockZzim: {
      type: Boolean,
      default: false
    },
    iconOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      value: false
    }
  },
  methods: {
    ...mapMutations(['showLoginPopup']),
    toggle (newState) {
      if (this.isMypooq) {
        if (showRequiredLoginPopup()) return
      } else if (cookie.getCredential() === 'none') {
        this.showLoginPopup()
        return
      } else if (cookie.isWavveOn()) {
        alert('웨이브온에서는 지원하지 않는 기능입니다.')
        return
      }

      let messageAdd
      let messageDelete
      if (this.contentsType === 'program') {
        messageAdd = constant.MSG_COMPLETE_ADD_ZZIM_PROGRAM
        messageDelete = constant.MSG_COMPLETE_DELETE_ZZIM_PROGRAM
      } else if (this.contentsType === 'live') {
        messageAdd = constant.MSG_COMPLETE_ADD_ZZIM_LIVE
        messageDelete = constant.MSG_COMPLETE_DELETE_ZZIM_LIVE
      } else if (this.contentsType === 'movie') {
        messageAdd = constant.MSG_COMPLETE_ADD_ZZIM_MOVIE
        messageDelete = constant.MSG_COMPLETE_DELETE_ZZIM_MOVIE
      } else if (this.contentsType === 'theme') {
        messageAdd = constant.MSG_COMPLETE_ADD_ZZIM_THEME
        messageDelete = constant.MSG_COMPLETE_DELETE_ZZIM_THEME
      }

      if (newState) { // off => on
        if (this.blockZzim) {
          // alert(constant.ZZIM_BLOCK_MESSAGE)
          this.$events.$emit('OPEN_PPV_TOAST', () => {}, constant.ZZIM_BLOCK_MESSAGE)
          return
        }
        // 좋아요 insert
        postZzimContentsDetail({
          contentid: this.contentsId,
          contenttype: this.contentsType,
          addalarm: 'y'
        }).then(({ data }) => {
          if (_.get(data, 'resultcode', '') === '550') {
            this.$events.$emit('OPEN_PPV_TOAST', () => {}, constant.ZZIM_BLOCK_MESSAGE)
            // alert(constant.ZZIM_BLOCK_MESSAGE)
          } else {
            this.value = true
            if (messageAdd) {
              this.$events.$emit('OPEN_PPV_TOAST', () => {}, messageAdd)
              // alert(messageAdd)
            }
          }
        })
      } else {
        // 좋아요 delete
        deleteZzimContents({
          contenttype: this.contentsType,
          contentids: [this.contentsId],
          delalarm: 'y'
        }).then(() => {
          this.value = false
          if (messageDelete) {
            this.$events.$emit('OPEN_PPV_TOAST', () => {}, messageDelete)
            // alert(messageDelete)
          }
        })
      }
    }
  },
  mounted () {
    this.value = this.isOn.toLowerCase() === 'y'
  }
}
</script>
